import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path d="M9 16v1.2a6 6 0 116 0V16a5 5 0 10-6 0zm0 4.49v1.05a10 10 0 116 0V20.5a9 9 0 10-6 0zm3.5-6.55V22h-1v-8.06a2 2 0 111 0z" /></svg>);